import React from "react";

// import { ReactComponent as AliorBankLogo } from "./assets/images/logos/alior-bank-logo.svg";
// import { ReactComponent as MBankRetailLogo } from "./assets/images/logos/mbank-sa-logo.svg";
// import { ReactComponent as MBankCorpoLogo } from "./assets/images/logos/mbank-corporate.svg";
// import { ReactComponent as MillenniumBankLogo } from "./assets/images/logos/millenium-bank-logo.svg";

// New Logos
import AliorLogo from "./assets/images/logos/bank/alior.png";
import MBankRetailLogo from "./assets/images/logos/bank/mbank-retail.png";
import MBankCorpoLogo from "./assets/images/logos/bank/mbank-corp.png";
import NestBankLogo from "./assets/images/logos/bank/nestbank.png";
import MilleniumLogo from "./assets/images/logos/bank/millenium2.png";
import PKOBPLogo from "./assets/images/logos/bank/pkobp.png";
import PKOSALogo from "./assets/images/logos/bank/pkosa.png";
import PocztowyLogo from "./assets/images/logos/bank/pocztowy.png";
import SantanderLogo from "./assets/images/logos/bank/santander.png";
import VeloLogo from "./assets/images/logos/bank/velo.png";
import InteligoLogo from "./assets/images/logos/bank/inteligo.png";
import IngLogo from "./assets/images/logos/bank/ing-bs.png";
import CreditAgricoleLogo from "./assets/images/logos/bank/credit-agricole.png";
import BOSLogo from "./assets/images/logos/bank/bos.png";
import BNPPAribasLogo from "./assets/images/logos/bank/bnp-paribas.png";

import BlikLogo from "./assets/images/logos/blik.png";

import ApplePayLogo from "./assets/images/logos/applepay-small.png";
import GooglePayLogo from "./assets/images/logos/googlepay-small.png";

// Images
export const LOGO_WIDTH = 100;
export const LOGO_HEIGHT = 50;

export const BASIC_METHODS = [
  {
    name: "blik",
    active: true,
    logo: <img src={BlikLogo} alt='Blik Logo' width={LOGO_WIDTH} />,
  },
  // { name: "card", active: true, logo: <img src={CardLogo} alt='Credit Card Logo' height={LOGO_HEIGHT} /> },
];

export const PSD2_METHODS = [
  { name: "pkobpbank", logo: <img src={PKOBPLogo} alt='PKOBP Bank Logo' width={LOGO_WIDTH} /> },
  { name: "pkosabank", logo: <img src={PKOSALogo} alt='PKOSA Bank Logo' width={LOGO_WIDTH} /> },
  { name: "aliorbank", logo: <img src={AliorLogo} alt='Alior Bank Logo' width={LOGO_WIDTH} height={LOGO_HEIGHT} /> },
  {
    name: "mbank-retail",
    logo: <img src={MBankRetailLogo} alt='mBank Retail Logo' width={LOGO_WIDTH} height={LOGO_HEIGHT} />,
  },
  {
    name: "mbank-corp",
    logo: <img src={MBankCorpoLogo} alt='mBank Corporate Logo' width={LOGO_WIDTH} height={LOGO_HEIGHT} />,
  },
  {
    name: "milleniumbank",
    logo: <img src={MilleniumLogo} alt='Millenium Bank Logo' width={LOGO_WIDTH} height={LOGO_HEIGHT} />,
  },
  { name: "ingbank", logo: <img src={IngLogo} alt='ING Bank Logo' width={LOGO_WIDTH} height={LOGO_HEIGHT} /> },
  {
    name: "santanderbank",
    logo: <img src={SantanderLogo} alt='Santander Bank Logo' width={LOGO_WIDTH} height={LOGO_HEIGHT} />,
  },
  { name: "bosbank", logo: <img src={BOSLogo} alt='BOŚ Bank Logo' width={LOGO_WIDTH} height={LOGO_HEIGHT} /> },
  { name: "nestbank", logo: <img src={NestBankLogo} alt='Nest Bank Logo' width={LOGO_WIDTH} /> },
  {
    name: "bnpparibasbank",
    logo: <img src={BNPPAribasLogo} alt='BNP Paribas Bank Logo' width={LOGO_WIDTH} height={LOGO_HEIGHT} />,
  },
  {
    name: "inteligobank",
    logo: <img src={InteligoLogo} alt='Inteligo Bank Logo' width={LOGO_WIDTH} height={LOGO_HEIGHT} />,
  },
  {
    name: "creditagricolebank",
    logo: <img src={CreditAgricoleLogo} alt='Credit Agricole Bank Logo' width={LOGO_WIDTH} />,
  },
  {
    name: "pocztowybank",
    logo: <img src={PocztowyLogo} alt='Pocztowy Bank Logo' width={LOGO_WIDTH} height={LOGO_HEIGHT} />,
  },
  { name: "velobank", logo: <img src={VeloLogo} alt='Velo Bank Logo' width={LOGO_WIDTH} height={LOGO_HEIGHT} /> },
];

export const WALLET_METHODS = [
  {
    name: "google-pay",
    logo: <img src={GooglePayLogo} alt='GooglePay Logo' width={LOGO_WIDTH} />,
  },
  {
    name: "apple-pay",
    logo: <img src={ApplePayLogo} alt='ApplePay Logo' width={LOGO_WIDTH} />,
  },
];

// Retry Config
export const API_CALL_TIMEOUT = process.env.REACT_APP_API_CALL_TIMEOUT || 4000;
export const API_CALL_PAY_TIMEOUT = process.env.REACT_APP_API_CALL_PAY_TIMEOUT || 25000;
export const API_RETRY_COUNT = process.env.REACT_APP_API_RETRY_COUNT || 3;
export const API_RETRY_DELAY = process.env.REACT_APP_API_RETRY_DELAY || 500;
export const RETRY_STATUS_CODES = [408, 500, 502, 503, 504];
export const RETRY_CODES = ["ECONNABORTED", "ERR_NETWORK"]; // Retry on client call timeout and no network connection.

// API
export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const API_PAYMENT_SELECTION = BASE_URL + "/payment_intent/transaction";
export const API_GET_PAYMENT_STATUS = BASE_URL + "/payment_intent/transaction";
export const API_GET_BLIK_STATUS = BASE_URL + "/payment_intent/transaction/blik";

// Timeouts in seconds for various payemnt status screens.
export const PAYMENT_SUCCESS_TIMEOUT = 10;
export const PAYMENT_CANCELED_TIMEOUT = 10;
export const PAYMENT_ERROR_TIMEOUT = 20;
export const BLIK_AUTH_TIMEOUT = 45;
export const BLIK_CONFIRM_TIMEOUT = 10;

// Languages
export const DEFAULT_LANGUAGE = "pl-PL";
export const LANGUAGES = [
  { lang: "pl-PL", name: "Polski", icon: "PL" },
  { lang: "en-GB", name: "English", icon: "GB" },
  { lang: "de-DE", name: "Deutsch", icon: "DE" },
  { lang: "bg-BG", name: "Български", icon: "BG" },
  { lang: "cs-CZ", name: "Čeština", icon: "CZ" },
  { lang: "da-DK", name: "Dansk", icon: "DK" },
  { lang: "el-GR", name: "Ελληνικά", icon: "GR" },
  { lang: "es-ES", name: "Español", icon: "ES" },
  { lang: "et-EE", name: "Eesti", icon: "EE" },
  { lang: "fi-FI", name: "Suomi", icon: "FI" },
  { lang: "fr-FR", name: "Français", icon: "FR" },
  { lang: "ga-IE", name: "Gaeilge", icon: "IE" },
  { lang: "hr-HR", name: "Hrvatski", icon: "HR" },
  { lang: "hu-HU", name: "Magyar", icon: "HU" },
  { lang: "it-IT", name: "Italiano", icon: "IT" },
  { lang: "lt-LT", name: "Lietuvių", icon: "LT" },
  { lang: "lv-LV", name: "Latviešu", icon: "LV" },
  { lang: "mt-MT", name: "Malti", icon: "MT" },
  { lang: "nl-NL", name: "Nederlands", icon: "NL" },
  { lang: "pt-PT", name: "Português", icon: "PT" },
  { lang: "ro-RO", name: "Română", icon: "RO" },
  { lang: "sk-SK", name: "Slovenčina", icon: "SK" },
  { lang: "sl-SI", name: "Slovenščina", icon: "SI" },
  { lang: "sv-SE", name: "Svenska", icon: "SE" },
];

export const BLIK_RETRY_TIME = 1000;

// Default Payment Method
export const DEFAULT_PAY_METHOD = "blik";
export const DEFAULT_PAY_LOGO = BASIC_METHODS.concat(PSD2_METHODS)
  .concat(WALLET_METHODS)
  .find((method) => method.name === DEFAULT_PAY_METHOD)?.logo;

export const SENTRY_DSN = "https://67466352465b595cf2cebaed14480b1a@sentry.archforges.com/4";
export const SENTRY_ENABLED = process.env.REACT_APP_SENTRY_ENABLED === "true";
export const IS_LOCAL_MODE = process.env.REACT_APP_ENV === "local";
export const FEATURE_INTENT_RETRY = true;

export const WEB_PAGE_URL = process.env.REACT_APP_WEB_PAGE_URL || "https://www.redpay.pl";
export const TERMS_URL =
  process.env.REACT_APP_TERMS_URL ||
  "https://redpay.pl/wp-content/uploads/2025/03/20241112_Regulamin-uslug-RedPay_v1.0_Final.pdf";

export const PRIVACY_POLICY_URL =
  process.env.REACT_APP_PRIVACY_POLICY_URL ||
  "https://redpay.pl/wp-content/uploads/2025/03/20241112_Polityka-prywatnosci-i-cookies-RedPay_v1.0_Final.pdf";
